import { configureStore, combineReducers } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import uiReducer from './slices/uiSlice';
import consultationUiReducer from './slices/consultationUiSlice';
import notificationReducer from './slices/notificationSlice';
import assistantChatReducer from './slices/assistantChatSlice';
import recorderReducer from './slices/recorderSlice';
import { storageSyncMiddleware } from './middleware/storageSyncMiddleware';

const rootReducer = combineReducers({
  auth: authReducer,
  ui: uiReducer,
  consultationUi: consultationUiReducer,
  notifications: notificationReducer,
  assistantChat: assistantChatReducer,
  recorder: recorderReducer,
});

/**
 * Factory function to create configured Redux store instance
 * (useful for creating fresh store instances in unit tests)
 */
export const createReduxStore = (preloadedState = {}) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          // Ignore non-serializable action payloads if needed
          ignoredActions: ['auth/setUser'],
        },
      }).concat(storageSyncMiddleware),
    devTools: process.env.NODE_ENV !== 'production',
  });
};

/** Default singleton application Redux store */
export const store = createReduxStore();

export default store;

// Export all slice actions and selectors for convenience
export * from './slices/authSlice';
export * from './slices/uiSlice';
export * from './slices/consultationUiSlice';
export * from './slices/notificationSlice';
export * from './slices/assistantChatSlice';
export * from './slices/recorderSlice';
export * from './hooks';
